import { HugeiconsIcon } from "@hugeicons/react";
import {
  ArrowDown02Icon,
  ArrowUp02Icon
} from "@hugeicons-pro/core-solid-rounded";

import { Show } from "shared/components";

type HeaderWithSortProps = {
  label?: string;
  columnKey: string;
  onSort: (columnKey: string) => void;
  sortDirection?: "ASC" | "DESC";
};

export const HeaderWithSort = ({
  label,
  columnKey,
  onSort,
  sortDirection
}: HeaderWithSortProps) => {
  const isActive = sortDirection !== undefined;
  const icon = sortDirection === "ASC" ? ArrowUp02Icon : ArrowDown02Icon;

  return (
    <button
      type="button"
      onClick={() => onSort(columnKey)}
      className="flex justify-start items-center gap-1 cursor-pointer"
    >
      <Show if={Boolean(label)}>
        <span className="text-xs font-medium text-content-300">{label}</span>
      </Show>
      <Show if={isActive}>
        <HugeiconsIcon
          size={16}
          className="text-content-300"
          stroke="1.33px"
          icon={icon}
        />
      </Show>
    </button>
  );
};
